import React from 'react'
import PackCommonCard from './PackCommonCard'
// import person from '../../src/telecaller/person.png'
// import activeDate from '../../src/telecaller/activeDate.png'
// import phone from '../../src/telecaller/phone.png'
// import pack from '../../src/telecaller/pack.png'
// import onlId from '../../src/telecaller/onlId.png'
import { PACKUPDATE, telecallerImage } from '../Configuration/Telecaller_URl'
import axios from 'axios'
import { AESEncryption, ApiResDecrypt } from '../CommonMethhods/CommonMethods'
import { toast } from 'react-toastify'


const PackUpdateNew = (clientDetails) => {
    console.log(clientDetails,"clientDetails");
    let updatePack = [
        // {
        //     person, onlId, phone, pack, activeDate
        // },
        {
            name: "Name", mobile: "Mobile Number", pack: "Pack Type", onlId: "ONL Id", active: "ONL ID Active Date"
        }
    ]
    const SendEmailSms = async () => {
        const sendEmailSmsReq = {
          "emailId": clientDetails.clientDetails.emailId,
          "mobileNo": clientDetails.clientDetails.mobile,
          "userId": localStorage.getItem("userId")
        }
        console.log(sendEmailSmsReq,"sendEmailSmsReq");
        let encPayload = AESEncryption(sendEmailSmsReq)
        try {
          const response = await axios.post(
            `${PACKUPDATE.SendEmailSms}`,
            encPayload,
    
            {
              headers: {
                "content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                reserv: 1,
              },
            }
          );
          const data = response.data;
          let getPackUpgradedata = ApiResDecrypt(data);
          if (getPackUpgradedata.status == 0) {
            // alert("success")
            toast.success(getPackUpgradedata.data);
          } else {
            // alert("error")
            toast.error(getPackUpgradedata.message);
          }
        } catch (err) {}
      };
    
      const EditPackTypeDetails = async () => {
        const packUpgrdePayload = {
          "mobileNo": clientDetails.clientDetails.mobile,
          "userId": localStorage.getItem("userId")
        }
        console.log(packUpgrdePayload,"packUpgrdePayload");
        let encPayload = AESEncryption(packUpgrdePayload)
        try {
          const response = await axios.post(
            `${PACKUPDATE.EditPackTypeDetails}`,
            // "https://uat-cosmos.bajajfinservsecurities.in/api/ekycadmin/Admin/EditPackTypeDetails",
            encPayload,
    
            {
              headers: {
                "content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                reserv: 1,
              },
            }
          );
          const data = response.data;
          let getPackUpgradedata = ApiResDecrypt(data);
          if (getPackUpgradedata.status == 0) {
            window.open(`${getPackUpgradedata.data.url}?mobileData=${AESEncryption(Number(clientDetails.clientDetails.mobile))}&uqIqData=${clientDetails.clientDetails.uqId}`)
          } else {
            toast.error(getPackUpgradedata.message);
          }
        } catch (err) {
        } finally {
        }
      };
      const maskNumber = (mobile) => {
        let mobileDigit = mobile.split("")
        mobileDigit = mobileDigit.map((digits, index) =>  index < mobileDigit.length - 4 ? '*' : digits);
        return mobileDigit.join("")
      };
    return (
        <div>

            <div className='rejection lead'>
                <div className="title-section lead-section">
                    <h2 className="card-title">Update Pack Details</h2>
                </div>
                <div className='client-datils update-table'>
                    {/* <div className='update-section'> */}
                    <PackCommonCard img={`${telecallerImage.person}`} title={updatePack[0].name} value={clientDetails.clientDetails.cName} />
                    <PackCommonCard img={`${telecallerImage.phone}`} title={updatePack[0].mobile} value={maskNumber(clientDetails.clientDetails.mobile)} />
                    <PackCommonCard img={`${telecallerImage.pack}`} title={updatePack[0].pack} value={clientDetails.clientDetails.packType} />
                    <PackCommonCard img={`${telecallerImage.onlId}`} title={updatePack[0].onlId} value={clientDetails.clientDetails.onlId} />
                    <PackCommonCard img={`${telecallerImage.activeDate}`} title={updatePack[0].active} value={clientDetails.clientDetails.onlIdDate} />
                    {/* </div> */}
                </div>
                <div className='payment'>
                    <button className='trigger'onClick={() => SendEmailSms()}>
                     
                      TRIGGER PAYMENT <img src={`${telecallerImage.trigger}`} alt="" /></button>
                    <button className='update'onClick={() => EditPackTypeDetails()}>
                    
                    UPGRADE PACK<img src={`${telecallerImage.updatePack}`} alt="" /></button>

                </div>

            </div>
        </div>
    )
}

export default PackUpdateNew